import medalBg from "../Asserts/images/medal_bg.svg";
import medalBgMobile from "../Asserts/images/medal_bg_mobile.svg";
import goldBg from "../Asserts/images/gold_bg.svg";
import goldBgMobile from "../Asserts/images/gold_bg_mobile.svg";
import silverBg from "../Asserts/images/silver_bg.svg";
import silverBgMobile from "../Asserts/images/silver_bg_mobile.svg";
import bronzeBg from "../Asserts/images/bronze_bg.svg";
import bronzeBgMobile from "../Asserts/images/bronze_bg_mobile.svg";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../services/axiosConfig";
import useDeviceType from "../Utiles/FindDevice";

export default function Champions() {
  const [championsData, setChampionsData] = useState([]);
  const [topChampions, setTopChampions] = useState([]);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const deviceType = useDeviceType();

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        
        // Handle token logic for guests
        const rawToken = localStorage.getItem("access_token");
        const token = (rawToken && rawToken !== "null" && rawToken !== "undefined") 
          ? JSON.parse(rawToken) 
          : null;

        const headers = {};
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }

        const response = await axios.get(`${baseURL}/pot/champions`, { headers });

        if (response.data.status === "Success") {
          const data = response.data.data;
          setChampionsData(data);

          const top3 = data?.champions?.slice(0, 3).map((champion, index) => ({
            name: champion.username,
            amount: Math.round(champion.gainlostamount),
            wins: champion.win_count,
            medal: index === 0 ? "gold" : index === 1 ? "silver" : "bronze",
            currency: champion.pot_currency,
          }));
          setTopChampions(top3);

          const remaining = data?.champions
            ?.slice(3)
            .map((champion, index) => ({
              rank: index + 4,
              name: champion.username,
              wins: champion.win_count,
              prize: Math.round(champion.gainlostamount),
              currency: champion.pot_currency,
            }));
          setLeaderboardData(remaining);
        }
      } catch (error) {
        console.error("Error fetching champions data:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const getMedalBg = (medal) => {
    const bgImages = {
      gold: deviceType === "mobile" ? goldBgMobile : goldBg,
      silver: deviceType === "mobile" ? silverBgMobile : silverBg,
      bronze: deviceType === "mobile" ? bronzeBgMobile : bronzeBg,
    };
    return bgImages[medal] || null;
  };

  const getTotalPayoutBg = () => {
    return deviceType === "mobile" ? medalBgMobile : medalBg;
  };

  return (
    <div className="w-full bg-white min-h-screen">
      <div className="w-full sm:w-[95.5%] mx-auto py-6 sm:py-8 px-4 sm:px-6 md:px-0">
        <h1 className="text-2xl sm:text-3xl sm:text-center md:text-left text-center font-bold font-archivo text-black mb-6 sm:mb-8">
          Champions
        </h1>

        {championsData?.champions?.length === 0 && !isLoading ? (
          <div className="flex items-center justify-center mt-20">
            <div className="text-center">
              <p className="text-gray-400 text-lg sm:text-xl font-medium font-archivo">
                Champions will be updated after the round is completed
              </p>
            </div>
          </div>
        ) : isLoading ? (
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="flex flex-col items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
              <p className="mt-4 text-gray-600 font-archivo">
                Loading champions data...
              </p>
            </div>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6 mb-8">
              {/* Total Payouts Card */}
              <div className="lg:col-span-1">
                <div
                  className="rounded-t-xl flex justify-between gap-4 p-4 sm:p-6 relative overflow-hidden h-full"
                  style={{
                    backgroundImage: `url(${getTotalPayoutBg()})`,
                    backgroundSize: "100%",
                    backgroundPosition: "right center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="relative z-10 ml-4">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2 font-archivo">
                      Total Payouts
                    </h3>
                    <div className="flex items-baseline gap-2">
                      <span className="md:text-[22px] sm:text-[18px] font-bold text-black font-archivo">
                        {championsData?.currency?.toUpperCase() === "USD" && "$"}{" "}
                        {championsData?.total_payout?.toLocaleString() || 0}
                      </span>
                      <span className="text-sm text-gray-600">
                        {championsData?.currency?.toUpperCase() === "USD"
                          ? null
                          : championsData?.currency?.toUpperCase()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Top Champions Cards */}
              <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-4">
                {topChampions?.map((champion, index) => (
                  <div
                    key={index}
                    className="rounded-t-xl p-4 sm:p-4 md:p-4 lg:p-8 relative overflow-hidden h-full flex flex-col justify-between"
                    style={{
                      backgroundImage: `url(${getMedalBg(champion.medal)})`,
                      backgroundSize: "100%",
                      backgroundPosition: "right center",
                      backgroundRepeat: "no-repeat",
                    }}
                  >
                    <div className="relative z-10 ml-4">
                      <h4 className="text-lg font-bold text-black mb-1 font-archivo">
                        {champion?.name
                          ? champion?.name.charAt(0).toUpperCase() +
                            champion.name.slice(1)
                          : ""}
                      </h4>
                      <div>
                        <span className="md:text-[22px] sm:text-[18px] font-bold text-black font-archivo">
                          {champion?.currency?.toUpperCase() === "USD" && "$"}{" "}
                          {champion?.amount?.toLocaleString()}
                        </span>

                        <span className="text-sm text-gray-600">
                          {champion?.currency?.toUpperCase() === "USD"
                            ? null
                            : champion?.currency?.toUpperCase()}
                        </span>
                      </div>
                    </div>
                    <div className="bg-[#BDE8FF] w-fit px-2 py-0.5 text-center rounded-md mt-1 ml-4">
                      <p className="text-[14px] text-[#082642] font-archivo">
                        Won {champion?.wins} times
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Leaderboard Table */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <div className="bg-gradient-to-r from-[#007FFF] to-[#00C05B] text-white">
                <div className="grid grid-cols-[50px_1fr_80px_1fr] sm:grid-cols-[60px_200px_140px_1fr] gap-2 sm:gap-4 p-3 sm:p-4 font-semibold text-xs sm:text-sm">
                  <div className="text-left">Rank</div>
                  <div className="text-left">Display Name</div>
                  <div className="text-center sm:text-left">
                    No. of Times Won
                  </div>
                  <div className="text-right">
                    Prize ({leaderboardData[0]?.currency?.toUpperCase() === 'USD' && '$'})
                  </div>
                </div>
              </div>

              <div>
                {leaderboardData?.map((player, index) => (
                  <div
                    key={index}
                    className="grid grid-cols-[50px_1fr_80px_1fr] sm:grid-cols-[60px_200px_140px_1fr] gap-2 sm:gap-4 p-3 sm:p-4 hover:bg-gray-50 transition-colors text-xs sm:text-sm"
                  >
                    <div className="text-left font-medium text-gray-900">
                      {player.rank}
                    </div>
                    <div className="text-left text-gray-900 truncate">
                      {player.name
                        ? player.name.charAt(0).toUpperCase() +
                          player.name.slice(1)
                        : ""}
                    </div>
                    <div className="md:text-center text-center text-gray-900">
                      {player.wins}
                    </div>
                    <div className="text-right font-medium text-gray-900">
                      {player.prize.toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}